import { FC } from "react";
import {
  Control,
  Controller,
  FieldValues,
  UseFormSetValue,
} from "react-hook-form";

import { TimeListItem } from "./time-list-item";

interface ITimeListItemRowProps {
  fieldName: string;
  index: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parentControl: Control<FieldValues, any>;
  parentSetValue: UseFormSetValue<FieldValues>;
  removeHandler: (index: number) => void;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

export const TimeListItemRow: FC<ITimeListItemRowProps> = ({
  fieldName,
  index,
  parentControl,
  parentSetValue,
  removeHandler,
  disabledEdit,
  disabledRemove,
}) => {
  return (
    <Controller
      name={`${fieldName}[${index}]`}
      control={parentControl}
      render={({ field: { value: itemValue } }) => (
        <TimeListItem
          fieldName={`${fieldName}[${index || 0}]`}
          index={index}
          value={itemValue}
          removeHandler={removeHandler}
          setValueOuter={parentSetValue}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
        />
      )}
    />
  );
};
